module.exports = __webpack_public_path__ + "img/hoslogo7.012b46f0.png";